/* ============================================================
   购物车 DIY 缩略图（2026-09-08 重写 · 第 2 版）
   --------------------------------------------------------------
   这一版做的事：把缩略图从「竖着叠两个小方块」改成「贺卡第一张那种款式网格」。

   为什么这么改（用户 2026-09-08 拍板）：
   - 旧版把左列写死 86px、图 70px，比主题原生 SKU 缩略图（80 / 128）窄一大截
   - 旧版竖着塞了「成品图 + 分隔线 + 魔尼带图 + 角标」，越挤越窄、越拖越高
   - 魔尼带那格是多余的：右边 properties 文字清单里已经写着「Moni-Strap 颜色」
   - 客人真正想看的是「我这套模块能搭出多少种样子」，那正是礼品贺卡第一张

   尺寸怎么保证跟 SKU 一致（关键设计）：
   实测主题原生缩略图 = `.cart-item__media`，它本身就是 80×80（<768px）/ 128×128（≥768px），
   而且已经是 position:relative。所以我们【不写死任何像素】，直接把网格
   position:absolute; inset:0 铺进这个盒子里 —— 主题怎么变，我们就怎么跟。

   网格密度（纯 CSS 响应式，不需要 JS 重排）：
   - 手机（<768px，盒子只有 80px）：2×2，只露前 4 款。4 格 × 38px 还看得清，
     16 格 × 19px 就是一堆色点了，所以手机不上 4×4。
   - 桌面（≥768px，盒子 128px）：≤4 款 2×2；>4 款 4×4（每格 29px，实测能读出配色差异）
   前两格必定是客人亲手配的第 1 / 第 2 副（enumerate 的排序保证），所以核对功能没丢。

   依赖：
   - window.RAINBOW_ASSETS（由 rainbow-asset-map snippet 注入的零件 PNG 地址表）
   - line item properties：_host_slug / _faceplate_slug{后缀} / _earpad_slug{后缀}
                           / _headband_slug{后缀} / _kit_count
     （kitCount>1 时后缀是 " (Set 1)" / " (Set 2)"，=1 时无后缀）
   ============================================================ */
(function () {
  'use strict';

  // DIY product handle 白名单：防止首页 Special Design Set 之类的行被误渲染
  const DIY_HANDLES = new Set(['rainbow-bundle', 'rainbow-duo', 'rainbow-trio']);

  // 套装名（角标左半边）。⚠️ 款式数【不再写死】，一律用 enumerate 现算，
  // 旧版把 Trio 写成 36 是错的（实际算出来是 15）。
  const DIY_VARIANT_NAMES = {
    '46073729384621': 'Bundle',
    '46073729712301': 'Duo',
    '46073731547309': 'Trio',
  };

  /* 半包耳锁死表（跟配置器 index.html 的 LOCKED_PAIRS 完全一致）：主机色 → 标配半包皮套色。
     ⚠️ 铁律：半包耳皮套跟着主机走，主机只有一个，所以【买几套都只有一副】。
        半包耳造型数变多，变的是头带，不是耳垫。 */
  const LOCKED_PAIRS = {
    silver: 'navy', desertyellow: 'darkgreen', babyblue: 'purple', green: 'brown',
  };

  /* ── 配色英文名（卡片槽里每张卡下面那行字要用）────────────────────
     全部取【店铺官方变体名】，不是自己编的 —— 客人在配件商品页看到的是同一个词。
     来源：配置器 index.html 的 HOST_EN / EARPAD_EN / SHOPIFY_MAPPING_INLINE.headband。
     ⚠️ 纯色头带（solid-*）店铺没有独立变体，官方映射表里查不到，用底色英文名兜底。 */
  const 色名 = {
    host: { silver:'Starry Silver', desertyellow:'Desert Yellow', babyblue:'Serene Blue', green:'Retro Green' },
    pad:  { navy:'Deep Blue', darkgreen:'Dark Green', purple:'Deep Purple', brown:'Coffee Brown' },
    headband: {
    'line-navy-yellow':'Blue and Yellow Line',
    'line-navy-red':'Blue and Red Line',
    'line-brown-green':'Brown and Green Line',
    'line-brown-yellow':'Brown and Yellow Line',
    'line-darkgreen-red':'Red and Green Line',
    'line-darkgreen-yellow':'Yellow and Green Line',
    'line-purple-yellow':'Purple and Yellow Line',
    'line-purple-navy':'Purple and Blue Line',
    'flower-navy':'Floral Blue',
    'flower-brown':'Floral Brown',
    'flower-darkgreen':'Floral Green',
    'flower-purple':'Floral Purple',
    'totem-navy':'Blue totem',
    'totem-brown':'Brown totem',
    'totem-darkgreen':'Green totem',
    'totem-purple':'Purple totem',
    'fluid-navy':'Flowing Blue',
    'fluid-brown':'Flowing Brown',
    'fluid-darkgreen':'Flowing Green',
    'fluid-purple':'Flowing Purple',
    'liuli-navy':'Liuli Blue',
    'liuli-brown':'Liuli Brown',
    'liuli-darkgreen':'Liuli Green',
    'liuli-purple':'Liuli Purple',
    'youth-navy':'Youth Blue',
    'youth-brown':'Youth Brown',
    'youth-darkgreen':'Youth Green',
    'youth-purple':'Youth Purple',
    'cube-navy':'Magic Cube Blue',
    'cube-brown':'Magic Cube Brown',
    'cube-darkgreen':'Magic Cube Green',
    'cube-purple':'Magic Cube Purple',
    'quantum-navy':'Quantum Blue',
    'quantum-brown':'Quantum Brown',
    'quantum-darkgreen':'Quantum Green',
    'quantum-purple':'Quantum Purple',
    'time-navy':'Year of Flow Blue',
    'time-brown':'Year of Flow Brown',
    'time-darkgreen':'Year of Flow Green',
    'time-purple':'Year of Flow Purple',
    },
  };
  色名.faceplate = 色名.host;   // 面盖跟主机色一一对应，英文名相同

  function 头带名(slug) {
    if (!slug) return '';
    if (色名.headband[slug]) return 色名.headband[slug];
    // solid-navy → Deep Blue
    const m = /^solid-(.+)$/.exec(slug);
    return (m && 色名.pad[m[1]]) || slug;
  }

  function 素材(type, slug) {
    if (!slug || !window.RAINBOW_ASSETS) return null;
    return window.RAINBOW_ASSETS[`素材/适配图/${type}-${slug}.png`] || null;
  }

  /* 款式枚举 —— 照搬配置器 index.html 的 enumerate()，逻辑必须一模一样，
     否则购物车说的款式数跟配置器/贺卡对不上。
     全包耳：面盖 × 全包皮套 × 头带（头带 = 主机自带的标配纯色 + 每套加购的设计头带）
     半包耳：唯一那副半包皮套 × 同一批头带
     排序：客人亲手装的那 1~2 副排最前，这样网格前两格就是他自己的配置。 */
  function 枚举款式(host, builds) {
    if (!host) return [];
    const 半包垫 = LOCKED_PAIRS[host];
    const 标配带 = 半包垫 ? `solid-${半包垫}` : null;

    const 面盖们 = builds.map(b => b.faceplate).filter(Boolean);
    const 皮套们 = builds.map(b => b.earpad).filter(Boolean);
    const 头带们 = [标配带, ...builds.map(b => b.headband)].filter(Boolean);

    const 出 = [];
    for (const fp of 面盖们) {
      for (const ep of 皮套们) {
        for (const hb of 头带们) {
          let 第几副 = -1;
          builds.forEach((b, i) => {
            if (b.faceplate === fp && b.earpad === ep && b.headband === hb && 第几副 < 0) 第几副 = i;
          });
          出.push({ 形态: 'overear', host, faceplate: fp, earpad: ep, headband: hb, 第几副 });
        }
      }
    }
    if (半包垫) {
      for (const hb of 头带们) {
        出.push({ 形态: 'halfear', host, faceplate: null, earpad: 半包垫, headband: hb, 第几副: -1 });
      }
    }
    出.sort((a, b) => (a.第几副 >= 0 ? a.第几副 : 99) - (b.第几副 >= 0 ? b.第几副 : 99));
    return 出;
  }

  // 一格 = 5 层叠图，层序必须是：投影 → 耳垫 → 面盖 → 主机 → 头带
  function 画一格(v) {
    const 半 = v.形态 === 'halfear';
    const 层 = [
      (window.RAINBOW_ASSETS || {})['素材/适配图/shadow.png'] || null,
      半 ? 素材('earpad', `halfear-${v.earpad}`) : 素材('earpad', v.earpad),
      半 ? null : 素材('faceplate', v.faceplate),
      半 ? 素材('host', `halfear-${v.host}`) : 素材('host', v.host),
      素材('headband', v.headband),
    ];
    const 格 = document.createElement('div');
    格.className = 'rb-thumb__cell';
    for (const src of 层) {
      if (!src) continue;
      const im = document.createElement('img');
      im.src = src;
      im.loading = 'eager';
      im.alt = '';
      格.appendChild(im);
    }
    return 格;
  }

  /* ════════════════════════════════════════════════════════════════
     款式气泡：点缩略图 → 从它身上弹出一个浮层，横排展示全部造型
     ────────────────────────────────────────────────────────────────
     ⚠️ 为什么浮层的 DOM 必须 append 到 document.body（2026-09-12 实测，别改回去）：
        购物车抽屉里 .drawer__inner 带 transform: matrix(1,0,0,1,0,0)
        （来自 .drawer[active] > .drawer__inner，永远不是 none），
        它会接管 position:fixed 的定位基准 —— 实测插一个 top:0 的 fixed 探针，
        量出来是视口 y=60px，而且还被 .drawer__inner 的 overflow:hidden 二次裁掉。
        再加上从缩略图到 body 一共有 6 层 overflow:hidden。
        所以浮层不能留在商品行里，必须真的搬到 body 直接子级。

     第 1 版做的是「商品行下面原地撑开」，实测被抽屉底部的
     Order note / Shipping / Discount 栏切掉，只露出卡片顶边 —— 所以改成浮层。
     ════════════════════════════════════════════════════════════════ */

  // 一张卡 = 一个款式的大图 + 底下配色字
  function 画卡片(v) {
    const 卡 = document.createElement('div');
    卡.className = 'rb-pop__card';

    const 图 = document.createElement('div');
    图.className = 'rb-pop__shot';
    // 复用 画一格()：叠图层序（投影→耳垫→面盖→主机→头带）跟缩略图/配置器必须一致
    const 内 = 画一格(v);
    内.className = 'rb-thumb__cell rb-pop__cell';
    图.appendChild(内);
    卡.appendChild(图);

    const 字 = document.createElement('div');
    字.className = 'rb-pop__meta';
    const 半 = v.形态 === 'halfear';
    const 行1 = document.createElement('span');
    行1.className = 'rb-pop__line1';
    // 半包耳没有面盖，写「Half-Ear + 皮套色」；全包耳写「面盖色 · 皮套色」
    行1.textContent = 半
      ? ('Half-Ear · ' + (色名.pad[v.earpad] || v.earpad || ''))
      : ((色名.faceplate[v.faceplate] || v.faceplate || '') + ' · ' + (色名.pad[v.earpad] || v.earpad || ''));
    const 行2 = document.createElement('span');
    行2.className = 'rb-pop__line2';
    行2.textContent = 头带名(v.headband);
    字.appendChild(行1); 字.appendChild(行2);
    卡.appendChild(字);
    return 卡;
  }

  /* 全局单例：同时只可能开一个气泡 */
  let 气泡 = null, 遮罩 = null, 宿主 = null, 卸载 = [];

  function 关气泡() {
    if (!气泡) return;
    const g = 气泡, z = 遮罩, h = 宿主;
    气泡 = 遮罩 = 宿主 = null;
    卸载.forEach(f => { try { f(); } catch (e) {} });
    卸载 = [];
    g.classList.remove('is-in');
    if (z) z.classList.remove('is-in');
    if (h) h.querySelector('.rb-thumb__col')?.classList.remove('is-open');
    // 等淡出动画跑完再移除，否则一瞬间就没了
    setTimeout(() => { g.remove(); if (z) z.remove(); }, 220);
  }

  /* 定位：优先浮在缩略图【上方】，上方放不下就翻到下方。
     尖角要指向缩略图中心，但气泡本身会被夹在屏幕内，所以尖角位置得单独算。 */
  function 定位(g, 尖, 锚rect) {
    const 视宽 = document.documentElement.clientWidth;
    const 视高 = document.documentElement.clientHeight;
    const 边距 = 12, 间隙 = 10;

    /* 上限按「一屏要露 4 张卡」倒推（用户明确要求「三张太少」）：
         手机 卡87 + 间距6 → 4 张需 4*87+3*6+22(内边距) = 388，屏宽 390-24=366 已经贴满
         桌面 卡124 + 间距8 → 4 张需 4*124+3*8+28 = 548
       所以上限给 560；宽屏不会撑得过分（1280 屏上占 44%）。 */
    const 宽 = Math.min(视宽 - 边距 * 2, 560);
    g.style.width = 宽 + 'px';

    let left = 锚rect.left + 锚rect.width / 2 - 宽 / 2;
    left = Math.max(边距, Math.min(left, 视宽 - 边距 - 宽));
    g.style.left = Math.round(left) + 'px';

    /* ⚠️ 朝上时用 bottom 定位，不要用 top。
       用 top 的话要先量高度，而这时卡片里的图【还没加载完】，量到的高偏小
       （实测定位时 158px，图加载完变 176px），气泡就往下长 18px 压住缩略图。
       改成钉住底边、向上生长，高度再怎么变都不会压过来。 */
    g.style.top = 'auto';
    g.style.bottom = Math.round(视高 - (锚rect.top - 间隙)) + 'px';
    g.classList.remove('is-down');

    // 量一次：上方真的放不下（顶出屏幕）才翻到下方
    const 上试 = g.getBoundingClientRect();
    const 朝上 = 上试.top >= 8;
    if (!朝上) {
      g.style.bottom = 'auto';
      g.style.top = Math.round(锚rect.bottom + 间隙) + 'px';
      g.classList.add('is-down');
      // 下方也放不下就夹在屏幕里（宁可盖住缩略图，也不能跑出屏幕外看不见）
      const 下试 = g.getBoundingClientRect();
      if (下试.bottom > 视高 - 8) {
        g.style.top = Math.round(Math.max(8, 视高 - 8 - 下试.height)) + 'px';
      }
    }

    // 尖角：指向缩略图中心，夹在气泡两端 18px 内，免得尖角挂到圆角上
    const 尖x = Math.max(18, Math.min(锚rect.left + 锚rect.width / 2 - left, 宽 - 18));
    尖.style.left = Math.round(尖x) + 'px';
    // 从缩略图那个点放大出来，而不是凭空淡入
    g.style.transformOrigin = 尖x + 'px ' + (朝上 ? '100%' : '0%');
  }

  function 开气泡(itemEl) {
    关气泡();
    const 款式 = itemEl._rb款式;
    if (!款式 || !款式.length) return;
    const 锚 = itemEl.querySelector('.rb-thumb__col');
    if (!锚) return;

    遮罩 = document.createElement('div');
    遮罩.className = 'rb-pop__veil';

    const g = document.createElement('div');
    g.className = 'rb-pop';
    g.setAttribute('role', 'dialog');
    g.setAttribute('aria-modal', 'false');

    const 头 = document.createElement('div');
    头.className = 'rb-pop__head';
    const 题 = document.createElement('span');
    题.className = 'rb-pop__title';
    题.textContent = (itemEl._rb套装名 ? itemEl._rb套装名 + ' · ' : '') + 款式.length + ' Looks';
    const 数 = document.createElement('span');
    数.className = 'rb-pop__count';
    头.appendChild(题); 头.appendChild(数);
    g.appendChild(头);

    const 轨 = document.createElement('div');
    轨.className = 'rb-pop__rail';
    款式.forEach(v => 轨.appendChild(画卡片(v)));
    g.appendChild(轨);

    /* ⚠️ Concept 主题有条全局规则会隐藏所有【空 div】——尖角是纯装饰、没有内容，
       第一版实测 getBoundingClientRect() 全是 0，压根没渲染出来。
       塞一个零宽空格当内容（CSS 里还加了 display:block !important 双保险）。 */
    const 尖 = document.createElement('div');
    尖.className = 'rb-pop__arrow';
    尖.textContent = '\u200b';
    g.appendChild(尖);

    document.body.appendChild(遮罩);
    document.body.appendChild(g);
    气泡 = g; 宿主 = itemEl;
    锚.classList.add('is-open');

    /* 计数「3 / 15」：按轨道滚到哪算当前露出的最后一张，比只报第一张更贴直觉 */
    const 更新计数 = () => {
      const 卡宽 = 轨.firstChild ? 轨.firstChild.getBoundingClientRect().width + 6 : 1;
      const 可见 = Math.max(1, Math.round(轨.clientWidth / 卡宽));
      const 当前 = Math.min(款式.length, Math.round(轨.scrollLeft / 卡宽) + 可见);
      数.textContent = 当前 + ' / ' + 款式.length;
    };
    定位(g, 尖, 锚.getBoundingClientRect());
    requestAnimationFrame(() => { g.classList.add('is-in'); 遮罩.classList.add('is-in'); 更新计数(); });

    轨.addEventListener('scroll', 更新计数, { passive: true });

    /* ── 关闭：点遮罩 / Esc / 下滑 / 外部滚动 ──
       ⚠️ 免疫期：刚弹出的头 450ms 一概不响应「滚动/点击关闭」。
          原因（2026-09-12 真机踩到，用户报「弹了一下就没了」）：
            · 点击那一下本身会带来惯性滚动、iOS 地址栏收放也派 scroll
            · 遮罩是在这次 click 之后才创建的，某些情况下同一串手势的
              后续 click 会落到刚出现的遮罩上，立刻把气泡关掉
          用一个时间戳挡住，比到处 stopPropagation 可靠。 */
    const 出生 = Date.now();
    const 过了免疫期 = () => Date.now() - 出生 > 450;

    遮罩.addEventListener('click', () => { if (过了免疫期()) 关气泡(); });
    const onKey = e => { if (e.key === 'Escape') 关气泡(); };
    document.addEventListener('keydown', onKey);
    卸载.push(() => document.removeEventListener('keydown', onKey));

    /* 抽屉是可滚动的，缩略图一滚就跑了，而气泡固定在视口上 —— 会脱节，所以要关。
       用捕获阶段监听：抽屉内部滚动不冒泡到 window，只有 capture 抓得到。
       ⚠️ 但必须把【气泡自己内部】的滚动排除掉 —— 卡片横滑也是 scroll 事件，
          不排除的话手指一滑卡片，气泡就自己关了（这就是「弹一下就没」的主因）。 */
    const onScroll = (e) => {
      if (!过了免疫期()) return;
      const 源 = e && e.target;
      if (源 && 源.nodeType === 1 && 气泡 && 气泡.contains(源)) return;   // 气泡内部滚动，不管
      关气泡();
    };
    document.addEventListener('scroll', onScroll, true);
    const onResize = () => { if (过了免疫期()) 关气泡(); };
    window.addEventListener('resize', onResize);
    卸载.push(() => { document.removeEventListener('scroll', onScroll, true);
                      window.removeEventListener('resize', onResize); });

    // 下滑关闭：只认竖向明显大于横向的滑动，否则会跟卡片横滑打架
    let y0 = null, x0 = null;
    const onTS = e => { const t = e.touches[0]; y0 = t.clientY; x0 = t.clientX; };
    const onTM = e => {
      if (y0 == null || !过了免疫期()) return;
      const t = e.touches[0];
      const dy = t.clientY - y0, dx = Math.abs(t.clientX - x0);
      // 竖向要明显大于横向，否则横滑卡片时手指稍微偏一点就被当成「下滑关闭」
      if (dy > 48 && dy > dx * 1.6) { y0 = null; 关气泡(); }
    };
    g.addEventListener('touchstart', onTS, { passive: true });
    g.addEventListener('touchmove', onTM, { passive: true });
  }

  /* 点击拦截 —— 必须的，不是可选项。
     实测：缩略图本身就是 <a href="/products/rainbow-duo?variant=…">，
     点下去会跳到 /pages/design（DIY 商品页重定向）**并且把整个抽屉销毁**。
     所以必须在【捕获阶段】拦，冒泡阶段已经来不及。 */
  function 装槽点击() {
    if (window.__rbSlotClickBound) return;
    window.__rbSlotClickBound = true;
    document.addEventListener('click', function (e) {
      const 柱 = e.target.closest && e.target.closest('.rb-thumb__col');
      if (!柱) return;
      const itemEl = 柱.closest('[data-rainbow-diy-rendered="1"]');
      if (!itemEl || !itemEl._rb款式) return;
      e.preventDefault();
      e.stopPropagation();
      // 再点一次同一个 = 收起
      if (宿主 === itemEl) 关气泡(); else 开气泡(itemEl);
    }, true);
  }

  function renderItem(itemEl, itemData) {
    const props = itemData.properties || {};
    const kitCount = parseInt(props._kit_count || '1', 10) || 1;

    // 从 properties 里还原客人配的那 1~N 副
    const builds = [];
    for (let i = 1; i <= kitCount; i++) {
      const 后缀 = kitCount > 1 ? ` (Set ${i})` : '';
      const b = {
        faceplate: props[`_faceplate_slug${后缀}`] || (i === 1 ? props._faceplate_slug : null) || null,
        earpad: props[`_earpad_slug${后缀}`] || (i === 1 ? props._earpad_slug : null) || null,
        headband: props[`_headband_slug${后缀}`] || (i === 1 ? props._headband_slug : null) || null,
      };
      if (b.faceplate || b.earpad || b.headband) builds.push(b);
    }
    const host = props._host_slug || null;
    const 款式 = 枚举款式(host, builds);
    if (!款式.length) return;   // 数据不全就别渲染，留主题原图比画错强

    /* 盒子：优先用主题原生的 .cart-item__media —— 它本身就是 80/128 且 position:relative，
       把网格铺进去就自动跟 SKU 一样宽，一个像素都不用写死。 */
    const 盒 = itemEl.querySelector('.cart-item__media')
            || (itemEl.querySelector('img') || {}).parentElement;
    if (!盒) return;
    if (getComputedStyle(盒).position === 'static') 盒.style.position = 'relative';

    // 主题原图留着但藏起来（它负责撑出盒子尺寸），只是别让它盖住网格
    const 原图 = 盒.querySelector('img');
    if (原图) { 原图.style.visibility = 'hidden'; }

    /* ── 单张主图 + 右下角小牌（2026-09-13 第 3 版）──────────────────
       第 2 版是 3×3 九宫格，用户评价「太小，看起来不高档」。
       真正的问题不是尺寸是形式：
         · 「展示 15 种款式」这件事已经被点开的气泡接管了，缩略图再塞 9 格是重复
         · 25px 的耳机既认不出是哪个配色，9 个色块堆一起也不像产品图
         · 同一个购物车里 SKU 商品是干净的产品图、DIY 是九宫格，看着像系统截图
       现在：一张正经产品图（客人亲手配的 Pair 1）+ 右下角一个写总数的小牌。
       ⚠️ 款式[0] 就是 Pair 1 —— 枚举时已经按「第几副」排序把它排到最前，
          不需要额外挑选逻辑。 */
    盒.querySelector('.rb-thumb__grid')?.remove();
    盒.querySelector('.rb-thumb__single')?.remove();
    const 主图 = 画一格(款式[0]);
    主图.className = 'rb-thumb__cell rb-thumb__single';
    盒.appendChild(主图);

    /* 小牌：告诉客人「这套模块还能配出 N 种」。
       ⚠️ 必须完全落在图框内 —— .cart-item__media 是 overflow:hidden，
          靠负偏移往外挪一点都会被裁掉。
       ⚠️ 里面必须有内容（数字本身就是）—— Concept 主题会隐藏所有空 div。 */
    盒.querySelector('.rb-thumb__badge')?.remove();
    if (款式.length > 1) {
      const 牌 = document.createElement('div');
      牌.className = 'rb-thumb__badge';
      牌.textContent = String(款式.length);
      盒.appendChild(牌);
    }

    /* 角标不能挂进 .cart-item__media（它 overflow:hidden，会被裁掉），
       也不能直接挂到它父容器上 —— 那是个【横向 flex】，角标会变成并排的第三项、
       飘到行中间去（2026-09-08 第一次推送就是这么翻的车）。
       正解：给缩略图套一根竖排「柱子」，图在上、角标在下，柱子整体替代原来那个 flex 项。 */
    const 套装名 = DIY_VARIANT_NAMES[String(itemData.variant_id)];
    itemEl.querySelector('.rb-thumb__looks')?.remove();
    const 角标 = document.createElement('div');
    角标.className = 'rb-thumb__looks';
    角标.textContent = (套装名 ? 套装名 + ' · ' : '') + 款式.length + ' Looks';

    let 柱 = itemEl.querySelector('.rb-thumb__col');
    if (!柱) {
      柱 = document.createElement('div');
      柱.className = 'rb-thumb__col';
      盒.parentElement.insertBefore(柱, 盒);
      柱.appendChild(盒);          // 把 .cart-item__media 原样搬进柱子，它自己的尺寸/样式不动
    }
    柱.appendChild(角标);

    itemEl.dataset.rainbowDiyRendered = '1';

    /* 气泡不在这里建 —— 它要按缩略图【当时的视口位置】定位，
       而抽屉可以滚、窗口可以转，位置每次都不一样，所以点的时候现建。
       这里只把数据挂在商品行上，给点击拦截用。
       放在 rainbowDiyRendered 之后：点击拦截靠这个属性认商品行。 */
    itemEl._rb款式 = 款式;
    itemEl._rb套装名 = 套装名;
    柱.classList.add('rb-thumb__col--tappable');
    柱.setAttribute('role', 'button');
    柱.setAttribute('tabindex', '0');
    柱.setAttribute('aria-label', 'Show all ' + 款式.length + ' looks');
  }

  // 找 cart line item 的 DOM 容器（主题差异容错）
  function findItemElement(item) {
    const k = item.key, vid = item.variant_id;
    const sels = [
      `[data-line-key="${k}"]`, `[data-key="${k}"]`, `[data-line-item-key="${k}"]`,
      `[data-item-key="${k}"]`, `[id="CartItem-${k}"]`,
      `[data-variant-id="${vid}"]`, `[data-variant="${vid}"]`,
    ];
    for (const s of sels) { const el = document.querySelector(s); if (el) return el; }
    const 候选 = document.querySelectorAll(
      '[class*="cart-item"], li.cart-item, tr.cart-item, .cart__items > *, [class*="line-item"]');
    for (const el of 候选) {
      if (el.dataset.rainbowDiyRendered) continue;
      // DOM 标记：隐藏属性不会渲染进 DOM，只能靠可见属性里的词。
      // 'Moni-Strap' 出现在每个 DIY 行的 Headset 那一行；'Host Color' 是改版前的老写法。
      const t = el.textContent || '';
      if (t.includes('Moni-Strap') || t.includes('Host Color')) return el;
    }
    return null;
  }

  /* ============================================================
     🚧 结账兜底拦截（2026-09-11 加）—— 这才是真正堵漏的那一层
     ------------------------------------------------------------
     漏洞：搜索页 / 推荐位 / 最近浏览里，DIY 商品的圆形 `+` 按钮是 **ajax 直接加购**，
     不经过商品页 → 商品页那条重定向【拦不住它】。客人就能买到一个身上
     一条配色信息都没有的 $299 套装，我们收到订单不知道该发什么颜色。

     所以在购物车这层兜底：发现「是 DIY 商品但没有 _host_slug」的行 →
     挡掉结账 + 给一条英文提示 + 一个「去配置器」按钮 + 一个「删掉它」按钮。

     为什么必须有「删掉它」：购物车里可能还躺着别的正常商品，光挡不给出路
     =把真实客人锁死在购物车里，比漏单还糟。

     为什么加速结账按钮（Shop Pay / PayPal）要整个藏掉而不是拦点击：
     它们渲染在 **iframe 里**，iframe 内部的点击我们根本监听不到，只能藏。
     ============================================================ */

  // 那三个 DIY 套装的 variant id（加购走的是 variant，不是 product）
  const DIY_VARIANT_IDS = new Set(Object.keys(DIY_VARIANT_NAMES));

  // 结账入口选择器（普通按钮 / 链接）
  const 结账选择器 = [
    '[name="checkout"]', 'button[name="checkout"]', 'input[name="checkout"]',
    'a[href="/checkout"]', 'a[href^="/checkout?"]', 'a[href*="/checkouts/"]',
    '[data-testid="Checkout-button"]',
  ].join(',');

  // 加速结账（在 iframe 里，拦不住点击，只能藏）
  const 加速选择器 = [
    '.shopify-payment-button', '[data-shopify="payment-button"]',
    'shopify-accelerated-checkout', 'shopify-accelerated-checkout-cart',
    '.cart__dynamic-checkout', '.additional-checkout-buttons',
    '.dynamic-checkout__content', '[data-shopify="dynamic-checkout-cart"]',
  ].join(',');

  let 问题行 = [];                     // [{key, title}]，为空 = 放行

  function 是DIY商品(item) {
    /* 认法两条（任一成立）：variant id 在白名单里，或 handle 在白名单里。
       ⚠️ 不能只认 properties —— 漏洞商品身上恰恰【什么属性都没有】。
       window.RAINBOW_DIY_TAGGED_VARIANTS 由 snippet 用 tag `diy-bundle` 现算注入，
       以后新增 DIY 套装只要打上这个 tag 就自动被认出来（见 snippet 注释）。 */
    const 额外 = window.RAINBOW_DIY_TAGGED_VARIANTS || [];
    return DIY_VARIANT_IDS.has(String(item.variant_id))
        || 额外.indexOf(String(item.variant_id)) >= 0
        || (item.handle && DIY_HANDLES.has(item.handle));
  }

  function 缺配色(item) {
    const p = item.properties || {};
    return !(p._host_slug || p['Host Color']);   // 'Host Color' 是改版前的老写法，兜底
  }

  function 带预览参数(路径) {
    const m = (location.search || '').match(/[?&]preview_theme_id=(\d+)/);
    return m ? 路径 + '?preview_theme_id=' + m[1] : 路径;
  }

  async function 删掉问题行(btn) {
    btn.disabled = true;
    btn.textContent = 'Removing…';
    try {
      for (const 行 of 问题行.slice()) {
        await fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: 行.key, quantity: 0 }),
        });
      }
      location.reload();   // 重载最省事：主题的购物车区块状态由它自己重建，我们不去手改
    } catch (e) {
      console.error('[Rainbow DIY Guard] 删除失败:', e);
      btn.disabled = false;
      btn.textContent = 'Remove it';
    }
  }

  function 造提示条() {
    const 条 = document.createElement('div');
    条.className = 'rb-diy-guard';
    条.setAttribute('role', 'alert');

    const 标 = document.createElement('p');
    标.className = 'rb-diy-guard__title';
    标.textContent = 'Finish designing your set before checkout';

    const 文 = document.createElement('p');
    文.className = 'rb-diy-guard__body';
    文.textContent = 'Your cart contains a Rainbow DIY set that has no colors chosen yet, '
      + 'so we would not know which parts to ship. Pick your colors in the designer '
      + '(about one minute), or remove this item to continue.';

    const 去 = document.createElement('a');
    去.className = 'rb-diy-guard__btn';
    去.href = 带预览参数('/pages/design');
    去.textContent = 'Design my set';

    const 删 = document.createElement('button');
    删.type = 'button';
    删.className = 'rb-diy-guard__remove';
    删.textContent = 'Remove it';
    删.addEventListener('click', function () { 删掉问题行(删); });

    const 行 = document.createElement('div');
    行.className = 'rb-diy-guard__actions';
    行.appendChild(去); 行.appendChild(删);

    条.appendChild(标); 条.appendChild(文); 条.appendChild(行);
    return 条;
  }

  function 更新拦截() {
    const 挡 = 问题行.length > 0;
    document.documentElement.classList.toggle('rb-diy-blocked', 挡);

    document.querySelectorAll(结账选择器).forEach(function (btn) {
      if (挡) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('rb-diy-blocked-btn');
        // 提示条插在结账按钮前面：客人不用点就看得见原因
        const 容 = btn.closest('form') || btn.parentElement;
        if (容 && !容.querySelector('.rb-diy-guard')) 容.insertBefore(造提示条(), 容.firstChild);
        // 加速结账在 iframe 里拦不住，只能藏（只藏结账按钮所在的容器内，别误伤商品页的 Buy it now）
        const 范围 = btn.closest('form') || btn.parentElement?.parentElement || document;
        范围.querySelectorAll?.(加速选择器).forEach(function (el) {
          if (!el.dataset.rbDiyHidden) { el.dataset.rbDiyHidden = el.style.display || 'auto'; }
          el.style.display = 'none';
        });
      } else {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('rb-diy-blocked-btn');
      }
    });

    if (!挡) {
      document.querySelectorAll('.rb-diy-guard').forEach(function (el) { el.remove(); });
      document.querySelectorAll('[data-rb-diy-hidden]').forEach(function (el) {
        el.style.display = el.dataset.rbDiyHidden === 'auto' ? '' : el.dataset.rbDiyHidden;
        delete el.dataset.rbDiyHidden;
      });
    }
  }

  function 装拦截器() {
    // 捕获阶段：抢在主题自己的结账逻辑之前，否则它已经把人送走了
    document.addEventListener('click', function (e) {
      if (!问题行.length) return;
      const t = e.target && e.target.closest && e.target.closest(结账选择器);
      if (!t) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      const 条 = document.querySelector('.rb-diy-guard');
      if (条) { 条.scrollIntoView({ block: 'center', behavior: 'smooth' }); 条.classList.add('rb-diy-guard--pulse'); }
    }, true);

    // 表单提交路径（回车 / 无 JS 的 name=checkout 提交）。
    // ⚠️ 只挡"提交人是结账按钮"的那次 —— 数量更新走的是同一个 form，挡了会把改数量弄瘫。
    document.addEventListener('submit', function (e) {
      if (!问题行.length) return;
      const 提交人 = e.submitter;
      if (提交人 && 提交人.name !== 'checkout') return;
      const f = e.target;
      if (!f || !/\/cart/.test(f.getAttribute('action') || '')) return;
      if (!提交人) return;                 // 提交人不明就别乱挡
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    }, true);
  }

  function 查问题行(cart) {
    问题行 = (cart.items || [])
      .filter(function (it) { return 是DIY商品(it) && 缺配色(it); })
      .map(function (it) { return { key: it.key, title: it.title }; });
    更新拦截();
  }

  async function scanAndRender() {
    try {
      const resp = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!resp.ok) return;
      const cart = await resp.json();
      查问题行(cart);      // ⚠️ 必须在画缩略图【之前】：下面哪一行画崩了也不能影响拦截
      for (const item of cart.items || []) {
        /* 怎么认出这是 DIY 商品：认隐藏属性 _host_slug。
           2026-09-10 之前认的是可见属性 'Host Color'，那次把可见属性合并成
           Headset / Pair 两行之后那个键就没了 —— 认隐藏属性更稳，它不随文案改动。
           `|| item.properties['Host Color']` 是给改版前就躺在购物车里的老商品兜底。 */
        const 是DIY = item.properties
          && (item.properties._host_slug || item.properties['Host Color']);
        if (!是DIY) continue;
        if (item.handle && !DIY_HANDLES.has(item.handle)) continue;
        const el = findItemElement(item);
        if (!el || el.dataset.rainbowDiyRendered === '1') continue;
        renderItem(el, item);
      }
    } catch (e) {
      console.error('[Rainbow Cart Thumb] 扫描失败:', e);   // 兜底 catch 必须出声，否则问题静默消失
    }
  }

  function init() {
    装槽点击();
    装拦截器();
    scanAndRender();
    let t;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(scanAndRender, 250); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
